// shadcn/ui の Accordion をそのまま re-export
// カスタマイズが必要な場合はここで拡張する
export {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/design-system/shadcn-ui/accordion';
